import { render, staticRenderFns } from "./OfferIssues.vue?vue&type=template&id=7fcb0e96&scoped=true&"
import script from "./OfferIssues.vue?vue&type=script&lang=ts&"
export * from "./OfferIssues.vue?vue&type=script&lang=ts&"
import style0 from "./OfferIssues.vue?vue&type=style&index=0&id=7fcb0e96&prod&scoped=true&lang=css&"
import style1 from "./OfferIssues.vue?vue&type=style&index=1&id=7fcb0e96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb0e96",
  null
  
)

export default component.exports